export default class UtilityCounterReadingsRequest {
    constructor(
        private readonly buildingId: string,
        private readonly fromDate: string,
        private readonly untilDate: string
    ) {}

    toJson(): {
        building_id: string;
        from_date: string;
        until_date: string;
        include_history: 0|1;
        include_inactive: 0|1;
    } {
        return {
            building_id: this.buildingId,
            from_date: this.fromDate,
            until_date: this.untilDate,
            include_history: 0,
            include_inactive: 0
        };
    }
}